import {
    OptionPicker,
    createOptionPicker,
} from '@vfde-brix/ws10/option-picker';
import { HtmlId } from '../enums/elementId';
import { mountComponent } from '../util/mount';
import { getCMSConfig } from '../util/cms';
import { CableProviderType } from '../enum';

/**
 * Create Brix Option Picker component.
 *
 * @param id - Wrapper ID of the element.
 * @param onChange - OnChange event.
 * @returns Option Picker component or
 * null if the element with the given ID is not found.
 */
export const mountOptionPicker = (id: HtmlId, onChange: (value: string) => void) =>
    mountComponent(id, createOptionPicker, {
        onChange: ({ target }) => {
            if (target && target instanceof HTMLInputElement) {
                onChange(target.value);
            }
        },
    });

/**
 * Disables all options if isEnabled is false and enables all if true
 *
 * @param optionPicker - Picker component to update
 * @param isEnabled - Whether options should be enabled
 */
export const setOptionPickerState = (optionPicker: OptionPicker | null, isEnabled: boolean) =>
    isEnabled ? optionPicker?.enableAllOptions() : optionPicker?.disableAllOptions();

/**
 * Updates tariff picker values depending on the current provider type
 * Replaces kdg with ume metacodes or vice-versa
 */
export const updateTariffPickerValuesByProvicer = (optionPicker: OptionPicker | null, providerType: CableProviderType) => {
    const props = optionPicker?.getProperties();
    const tariffIds = Object.values(getCMSConfig().tariffIds[providerType]);

    if (!props || props.items.length !== tariffIds.length) {
        return;
    }

    props.items.forEach((item, index) => {
        item.stdValue = tariffIds[index];
    });

    optionPicker?.update(props);
};
